import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { ClientParentDetails } from '@client-parents/models/client-parent-details';

@Injectable({
  providedIn: 'root'
})

export class ClientParentDetailsHttpService {

  constructor(
    private readonly http: HttpClient,
    private readonly urlBuilder: UrlBuilderService
  ) { }

  getDetails(clientParentRef: number): Observable<ClientParentDetails> {
    const url = this.urlBuilder.getUrl(`client-parent/${clientParentRef}/details`);
    return this.http
      .get<ClientParentDetails>(url).pipe(
        map(details => details || undefined)
      );
  }

}
